import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import * as React from 'react';
import { InputField } from '../InputField';
import { EKeyCode } from '../../types/keyCodes';
import * as styles from './PinInput.css';
export var PinInput = function PinInput(_ref) {
  var value = _ref.value,
      disabled = _ref.disabled,
      invalid = _ref.invalid,
      length = _ref.length,
      onChange = _ref.onChange,
      onSubmit = _ref.onSubmit,
      onCompletedChange = _ref.onCompletedChange;
  var elements = React.useMemo(function () {
    return [];
  }, []);
  var normalizedValue = React.useMemo(function () {
    return Array.from({
      length: length
    }, function (_, index) {
      return value[index] || '';
    });
  }, [length, value]);
  var currentPinLength = React.useMemo(function () {
    return normalizedValue.filter(function (chunk) {
      return chunk.length > 0;
    }).length;
  }, [normalizedValue]);
  var isPinCompleted = currentPinLength === length;
  React.useEffect(function () {
    if (currentPinLength !== 0) {
      return;
    }

    var firstElement = elements[0];

    if (firstElement) {
      firstElement.focus();
    }
  }, [currentPinLength, elements]);
  React.useEffect(function () {
    if (!onCompletedChange) {
      return;
    }

    onCompletedChange(isPinCompleted);
    /**
     * Убрал из зависимостей onCompletedChange, поскольку он провоцирует повторную отправку
     * запроса register-or-authorize-user во frontend-mobile-website.
     */
  }, [isPinCompleted]);

  var handleInputChange = function handleInputChange(e, index) {
    var targetValue = e.currentTarget.value;

    var nextValue = _toConsumableArray(normalizedValue);

    var nextElement = elements[index + 1];
    nextValue[index] = targetValue;
    onChange(nextValue);

    if (targetValue.length > 0 && nextElement) {
      nextElement.focus();
    }
  };

  var handleKeyDown = function handleKeyDown(e, index) {
    var value = normalizedValue[index];

    if (e.keyCode === EKeyCode.Backspace && !value) {
      var previousElement = elements[index - 1];

      if (previousElement) {
        previousElement.focus();
      }

      return;
    }

    if (e.keyCode === EKeyCode.Enter && isPinCompleted) {
      onSubmit();
      return;
    }
  };

  var handleFocus = React.useCallback(function (e) {
    e.target.select();
  }, []);
  return /*#__PURE__*/React.createElement("div", {
    className: styles['container']
  }, normalizedValue.map(function (inputValue, index) {
    return /*#__PURE__*/React.createElement(InputField, {
      value: inputValue,
      ref: function ref(r) {
        return elements[index] = r;
      },
      key: "pin_input_".concat(index),
      name: "pin_input_".concat(index),
      type: "tel",
      fieldType: "pin",
      invalid: invalid,
      disabled: disabled,
      onFocus: handleFocus,
      onKeyDown: function onKeyDown(e) {
        return handleKeyDown(e, index);
      },
      onChange: function onChange(e) {
        return handleInputChange(e, index);
      }
    });
  }));
};
PinInput.displayName = 'PinInput';